import { render, staticRenderFns } from "./MsgRecords.vue?vue&type=template&id=718a40f4"
import script from "./MsgRecords.vue?vue&type=script&lang=js"
export * from "./MsgRecords.vue?vue&type=script&lang=js"
import style0 from "./MsgRecords.vue?vue&type=style&index=0&id=718a40f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports